// antd keeps `null` in the form once the admin clears the input.
export const normalizeCustomPrice = (
  value: number | null | undefined,
): number | undefined => (typeof value === 'number' ? value : undefined);

export const getInvoicePrice = (
  listPrice: string | undefined,
  customPrice: number | undefined,
): number => customPrice ?? Number(listPrice ?? 0);
